import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SortableTable from "../Components/SortableTable";
import Title from "../Components/Title";
import { showPopupSnackbar } from "../redux/actions/snackbarActions";
import { getToken } from "../Utils/Common";
import EnvSettings from "../Utils/EnvSettings";
import { useStyles } from "../Utils/Styles";

const server = EnvSettings.server;

function formatCompanyData(data) {
  var arr = [];
  data.forEach((element) => {
    arr.push({
      id: element.id,
      companyName: element.companyName,
    });
  });
  return arr;
}

export default function Companies(props) {
  const classes = useStyles();
  const history = useHistory();
  const [companies, setCompanies] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let getCompanies = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken() }),
    };
    fetch(server + "/get_companies", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        if (process.env.NODE_ENV !== "production") {
          console.log(result);
        }
        if (result.error) {
          dispatch(showPopupSnackbar(result));
        } else {
          setCompanies(formatCompanyData(result.companies));
        }
      });
  };

  let showCompany = (id) => {
    history.push("/cpanel/companies/" + id);
  };

  useEffect(getCompanies, []);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Button
            onClick={() => {
              history.push("/cpanel/companies/new");
            }}
          >
            {t("companies.newCompany")}
          </Button>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Title>{t("companyList.header")}</Title>
          {companies ? (
            <SortableTable
              data={{
                headCells: [
                  {
                    id: "companyName",
                    numeric: false,
                    disablePadding: false,
                    label: t("companyList.company"),
                  },
                ],
                defaultSortRow: "companyName",
                handleRowClick: showCompany,
                tableData: companies,
                rowsPerPage: 25,
              }}
            />
          ) : undefined}
        </Paper>
      </Grid>
    </Grid>
  );
}
